import { DatePicker, Input } from 'antd';

export const useAnounceInfoFields = () => {
  const anounceFields = [
    {
      name: ['reference'],
      rules: [{ required: true }],
      input: <Input disabled />
    },
    {
      name: ['start_date'],
      input: <DatePicker disabled format="DD/MM/YYYY" />
    },
    {
      name: ['end_date'],
      input: <DatePicker disabled format="DD/MM/YYYY" />
    },
    {
      name: ['state']
    }
  ];

  return { anounceFields };
};
